/**
 * Copyright 2021 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
'use memo';
import { type ComponentType } from 'react';
import cx from 'classnames';
import styles from '../styles.module.scss';
import azCommonStyles from '../../../../theme/globals.module.scss';
import BreadcrumbSeparator from './BreadcrumbSeparator';
import { type BreadcrumbItemType } from '../utils/isBreadcrumbModel';

type Props = {
  isLastItem: boolean;
  item: BreadcrumbItemType;
  onClick?: (e: Event, item: BreadcrumbItemType) => void;
  linkComponent: ComponentType<any>;
  lastItemDisabled?: boolean;
  itemClassName?: string;
  separatorClassName?: string;
};

const BreadcrumbItem = (props: Props) => {
  const {
    isLastItem,
    item,
    onClick,
    linkComponent: Link,
    lastItemDisabled,
    itemClassName,
    separatorClassName,
  } = props;

  return (
    <span className={cx(azCommonStyles['az-caption'], styles['breadcrumb-item'], itemClassName)}>
      {lastItemDisabled && isLastItem ? (
        <span className={cx(styles['breadcrumb-link'], styles.breadcrumbDisabled)}>
          {item.displayName || item?.label || item?.categoryName}
        </span>
      ) : (
        <Link
          href={item?.canonicalPath || item?.url || item?.canonicalUrl}
          onClick={(e: any) => onClick?.(e, item)}
          className={cx(styles['breadcrumb-link'])}
          samePage
        >
          {item.displayName || item?.label || item?.categoryName}
        </Link>
      )}
      {!isLastItem && <BreadcrumbSeparator className={separatorClassName} />}
    </span>
  );
};

export default BreadcrumbItem;
